if (document.querySelector('.collection-hero__text-wrapper .full-description')) {
  var text = document.querySelector('.collection-hero__text-wrapper .full-description .text');
  var btn = document.querySelector('.collection-hero__text-wrapper .full-description #read-more-btn');

  if (text.scrollHeight > text.clientHeight) {
    btn.classList.add('is-visible');

    // TODO: Should this be attached to the whole description or just button?
    btn.addEventListener('click', function () {
      const isExpanded = text.classList.toggle('is-visible');
      btn.classList.toggle('is-visible', !isExpanded);
      btn.setAttribute('aria-expanded', isExpanded.toString());

      if (isExpanded) {
        setTimeout(() => {
          text.setAttribute('tabindex', '-1');
          text.focus({ preventScroll: true });
        }, 100);
      }
    });

    btn.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        btn.click();
      }
    });
  }
}

